import React from "react";
import { Link } from "react-router-dom";
import {
  FaHandsHelping,
  FaTree,
  FaGraduationCap,
  FaArrowRight,
  FaHeart,
} from "react-icons/fa";

const HomePage = () => {
  const highlights = [
    {
      icon: <FaHandsHelping />,
      title: "Aabharan Shakti",
      text: "Empowering women through skills, dignity and self-reliance.",
    },
    {
      icon: <FaTree />,
      title: "Ankuran Bandhan",
      text: "Creating a greener future by linking every child with a tree.",
    },
    {
      icon: <FaGraduationCap />,
      title: "Yuva Utkarsh",
      text: "Building a confident generation through education and awareness.",
    },
  ];

  return (
    <div className="min-h-screen bg-white font-sans m-0 p-0">
      <section className="relative overflow-hidden bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] py-14 md:py-18 px-4">
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#1298b5]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#f97316]/10 rounded-full blur-3xl"></div>

        <div className="relative max-w-7xl mx-auto text-center">
          <span className="inline-block bg-white text-[#1298b5] border border-[#bdeef5] px-5 py-2 rounded-full text-sm font-semibold mb-5 shadow-sm">
            Welcome to Aabharan Foundation
          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold text-[#073b4c] mb-5 leading-tight">
            सज्जित जीवन,{" "}
            <span className="text-[#1298b5]">सशक्त भविष्य</span>
          </h1>

          <p className="text-xl md:text-3xl text-[#073b4c] font-medium">
            Adorning Lives, Empowering Futures
          </p>

          <div className="w-24 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto mt-6 rounded-full"></div>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/donation"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#1298b5] to-[#0b819b] hover:from-[#f97316] hover:to-[#fb923c] text-white px-7 py-3 rounded-full font-bold shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              Support Our Cause <FaHeart />
            </Link>

            <Link
              to="/about-us"
              className="inline-flex items-center gap-2 bg-white text-[#1298b5] border border-[#bdeef5] hover:border-[#1298b5] px-7 py-3 rounded-full font-bold shadow-md transition-all duration-300 hover:-translate-y-1"
            >
              Learn More <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full bg-white py-14 md:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl p-7 md:p-12 border border-[#d8f4f8]">
            <div className="max-w-4xl mx-auto text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-extrabold text-[#073b4c] mb-4">
                A New Journey of{" "}
                <span className="text-[#1298b5]">Empowerment and Care</span>
              </h2>

              <div className="w-20 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded-full"></div>
            </div>

            <div className="text-gray-700 text-base md:text-lg leading-relaxed">
              <p className="mb-4">
                <span className="font-semibold text-[#073b4c]">
                  Dear Friend and Supporter,
                </span>
              </p>

              <p className="mb-4">
                It is with great humility and excitement that we introduce you
                to{" "}
                <span className="font-bold text-[#1298b5]">
                  Aabharan Foundation
                </span>
                . The word{" "}
                <span className="font-semibold text-[#1298b5]">Aabharan</span>{" "}
                signifies an ornament—something that adds value, beauty, and
                dignity. Our foundation was born out of a simple yet powerful
                realization: true social change happens when we empower the
                hands that build our homes and nurture the soil that sustains
                our lives.
              </p>

              <p className="mb-6">
                At Aabharan, we aren’t just launching programs; we are building
                a family.
              </p>

              <div className="grid md:grid-cols-3 gap-5 mb-8">
                {highlights.map((item, index) => (
                  <div
                    key={index}
                    className="group bg-[#f8fdfe] border border-[#d8f4f8] hover:border-[#1298b5]/50 rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all duration-300"
                  >
                    <div className="w-12 h-12 bg-[#eafaff] text-[#1298b5] group-hover:bg-[#1298b5] group-hover:text-white rounded-xl flex items-center justify-center text-2xl mb-4 transition-all">
                      {item.icon}
                    </div>

                    <h3 className="text-lg font-bold text-[#073b4c] mb-2">
                      {item.title}
                    </h3>

                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>

              <p className="mb-4">
                We invite you to be a part of this journey. Whether you
                contribute your time, your resources, or simply spread our
                message, you are helping us with “Adorn Lives and Shape
                Futures.”
              </p>

              <p className="mb-6">
                Thank you for believing in our vision. Together, let’s make a
                difference that lasts for generations.
              </p>

              <div className="bg-gradient-to-br from-[#eafaff] to-white border border-[#d8f4f8] rounded-2xl p-5">
                <p className="font-bold text-[#073b4c]">With gratitude,</p>
                <p className="text-[#1298b5] font-bold">
                  The Aabharan Foundation Team
                </p>
                <p className="text-sm text-gray-500 italic mt-1">
                  Sajaayein Jeevan, Sanwaarein Bhavishya
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-gradient-to-r from-[#1298b5] via-[#0b819b] to-[#073b4c] py-6 text-center px-4">
        <span className="text-white font-semibold text-sm md:text-base">
          सज्जित जीवन, सशक्त भविष्य — Adorning Lives, Empowering Futures
        </span>
      </section>
    </div>
  );
};

export default HomePage;